var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[(_vm.isLoading)?_c('div',[_c('OtherLoading',{attrs:{"variant":"dark"}})],1):_c('div',[_c('div',{staticClass:"content-history"},[_c('RewardHistory',{attrs:{"list":_vm.rewardsHistory}}),_c('infinite-loading',{ref:"infiniteLoading",on:{"infinite":_vm.infiniteHandler}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }